export default __webpack_public_path__ + "alberta-chat-assign.48a9312e45e4ee2b0dfb.svg";